import { ILoginParam } from 'src/entity/LoginParam';

class StorageService {
  setItem(key: string, value: string): void {
    // localStorage.setItem(key, value);
    sessionStorage.setItem(key, value);
  }

  getItem(key: string): string | null {
    return sessionStorage.getItem(key);
    // return localStorage.getItem(key);
  }

  removeItem(key: string): void {
    sessionStorage.removeItem(key);
    // localStorage.removeItem(key);
  }

  setUserStorage(value: ILoginParam): void {
    if (!!value) {
      sessionStorage.setItem('user', JSON.stringify(value));
      // localStorage.setItem('user', JSON.stringify(value));
    }
  }

  getUserStorage(): ILoginParam | undefined {
    const userStr: string | null = sessionStorage.getItem('user');
    // const userStr: string | null = localStorage.getItem('user');
    return !!userStr ? JSON.parse(userStr) : undefined;
  }

  // setUserTypeStorage(value: { type: string }): void {
  //   if (!!value) {
  //     localStorage.setItem('userType', JSON.stringify(value));
  //   }
  // }

  // getUserTypeStorage(): { type: string } | undefined {
  //   const typeString: string | null = localStorage.getItem('userType');
  //   return !!typeString ? JSON.parse(typeString) : undefined;
  // }
}

export default new StorageService();



// WEBPACK FOOTER //
// ./src/services/StorageService.ts